export const CheckMarkIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2618 3.84937C13.1956 2.78312 12.6625 2.25 12 2.25C11.3375 2.25 10.8044 2.78312 9.73815 3.84937C9.09832 4.4892 8.46427 4.78626 7.55208 4.78626C6.7556 4.78626 5.62243 4.63178 5 5.25944C4.38249 5.88214 4.53628 7.01065 4.53628 7.80206C4.53628 8.71428 4.2392 9.34832 3.59935 9.98817C2.53312 11.0544 2.00001 11.5875 2 12.25C2.00002 12.9124 2.53314 13.4456 3.59938 14.5118C4.31616 15.2286 4.53628 15.6914 4.53628 16.6979C4.53628 17.4944 4.38181 18.6276 5.00949 19.25C5.63218 19.8675 6.76068 19.7137 7.55206 19.7137C8.52349 19.7137 8.99128 19.9037 9.68457 20.597C10.2749 21.1874 11.0663 22.25 12 22.25C12.9337 22.25 13.7251 21.1874 14.3154 20.597C15.0087 19.9037 15.4765 19.7137 16.4479 19.7137C17.2393 19.7137 18.3678 19.8675 18.9905 19.25M18.9905 19.25C19.6182 18.6276 19.4637 17.4944 19.4637 16.6979C19.4637 15.6914 19.6838 15.2286 20.4006 14.5118C21.4669 13.4456 22 12.9124 22 12.25C22 11.5875 21.4669 11.0544 20.4006 9.98817M18.9905 19.25H19"
        stroke="#009C8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 9.75L12 13.25L21.0002 3.25"
        stroke="#009C8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
